import React from 'react';
import classNames from 'classnames';

export default function CollapseIcon({ className = '' }) {
	return <span className={classNames('icon icon-caret', className)} />;
}
